var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "164px",
    viewBox: "0 0 164 164",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-publish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finlistics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd-6",
    transform: "translate(-1787.000000, -1697.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-publish",
    transform: "translate(1787.000000, 1697.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 82,
    cy: 82,
    r: 82
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(32.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.784748,34 C33.7665006,34 0,44.4416105 0,64.5751312 C0,65.2580039 5.23564797,64.6568602 14.0308038,64.5751312 C18.6407447,64.5322933 27.9946139,64.5322933 42.0924114,64.5751312 C46.5480323,64.4882149 71.5897307,65.5731465 72.4924864,64.5751312 C80.686328,55.5166673 67.3144106,34 53.784748,34 Z",
    id: "Oval",
    fill: "#7BC440",
    opacity: 0.894042969
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 0.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,62 L61,54.8461538 C61,46.9442336 54.1723424,40.5384615 45.75,40.5384615 L15.25,40.5384615 C6.82765757,40.5384615 0,46.9442336 0,54.8461538 L0,62",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 29.3269231,
    cy: 14.3076923,
    rx: 15.25,
    ry: 14.3076923
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(96.000000, 47.000000)",
    stroke: "#0D0D0D",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 34,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "4 2 19.2105263 14 32 2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.af67c9aabd714c84bb0199f8b0778610.svg";
export { ForwardRef as ReactComponent };